import { type ReactNode, useState } from "react"
import { cn } from "~/lib/utils"
import { Badge } from "./ui/badge"
import { Button } from "./ui/button"

export function ButtonPanel({
	buttons,
	children
}: {
	buttons: Array<{
		onClick: () => void | Promise<void>
		children: ReactNode
		icon?: ReactNode
		className?: string
		badgeText?: string
	}>
	children?: ReactNode
}) {
	const [loadingStates, setLoadingStates] = useState<boolean[]>(
		new Array(buttons.length).fill(false)
	)

	return (
		<div className="bg-background-secondary w-full items-center justify-center rounded-md p-4 sm:p-8 flex flex-col gap-4">
			{children}
			{children && buttons.length > 0 && (
				<div className="flex w-full items-center gap-3">
					<div className="h-px flex-1 bg-stroke" />
					<span className="text-xs text-text-small">or</span>
					<div className="h-px flex-1 bg-stroke" />
				</div>
			)}
			{buttons.map((button, index) => (
				<div key={index} className="relative w-full">
					<Button
						onClick={async () => {
							setLoadingStates((prev) => {
								const newStates = [...prev]
								newStates[index] = true
								return newStates
							})
							try {
								await Promise.resolve(button.onClick())
							} finally {
								setLoadingStates((prev) => {
									const newStates = [...prev]
									newStates[index] = false
									return newStates
								})
							}
						}}
						className={cn(
							"w-full flex flex-row gap-2 rounded-lg",
							button.className
						)}
						disabled={loadingStates[index]}
						pending={loadingStates[index]}
						icon={button.icon}
					>
						{button.children}
					</Button>
					{button.badgeText && (
						<Badge className="absolute -top-2 -right-2 z-10">
							{button.badgeText}
						</Badge>
					)}
				</div>
			))}
		</div>
	)
}
